import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { HistoryLogsComponent } from "./history-logs/history-logs.component";

const routes: Routes = [
  {
    path: "",
    redirectTo: "history-logs",
    pathMatch: "full"
  },
  {
    path: "history-logs",
    component: HistoryLogsComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LogsRoutingModule {}
